class AlgoliaShowCurrentRefinements extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.createWidget = this.createWidget.bind(this);
    this.getCount = this.getCount.bind(this);
    this.render = this.render.bind(this);
    this.renderContainer = this.renderContainer.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.toggleRefinements = this.toggleRefinements.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      filterAndSort: this.getAttribute('filter-and-sort')
    }
  }

  /**
   * Creates an instance of the show current refinements widget.
   * @param {Object} configuration - Configuration object for rendering.
   * @param {Object} instances - Instances object containing algolia instances.
   * @returns {Object} The created show current refinements widget instance.
   */
  createWidget(configuration, instances) {
    const { connectCurrentRefinements } = instances.algoliaShopify.externals.connectors;
    const connectedCurrentRefinements = connectCurrentRefinements(this.render);

    const selector = `.${configuration.container}`;
    const container = document.querySelector(selector);

    const showCurrentRefinementsWidget = connectedCurrentRefinements({ container });
    return showCurrentRefinementsWidget;
  }

  /**
   * Returns the count of current refinements.
   * @param {Array} items - The number of items retrieved.
   * @returns {string} The count of current refinements.
   */
  getCount(items) {
    const count = items.reduce((previous, current) => previous + current.refinements.length, 0);
    return count;
  }

  /**
   * Renders the show current refinements widget with the provided render options.
   * @param {Object} renderOptions - Options for rendering the widget.
   * @param {boolean} isFirstRender - Indicates whether this is the first render.
   * @returns {void}
   */
  render(renderOptions, isFirstRender) {
    if (isFirstRender) return;

    const { items, widgetParams } = renderOptions;
    const { container } = widgetParams;
    container.innerHTML = '';
    const count = this.getCount(items);

    container.appendChild(this.renderContent(count));

    const summary = container.querySelector('summary');
    if (!summary) return;

    summary.addEventListener('click', this.toggleRefinements);
  }

  /**
   * Renders the container for the show current refinements widget.
   * @param {Object} configuration - Configuration object for rendering.
   * @param {Function} html - The HTML template function.
   * @returns {string} The rendered container.
   */
  renderContainer(configuration, html) {
    return html`<div class="${configuration.container} mobile-facets__wrapper large-up-hide"></div>`;
  }

  /**
   * Renders the content.
   * @param {number} - The count of current refinements.
   * @returns {string} The rendered content HTML.
   */
  renderContent(count) {
    // <div class="mobile-facets__disclosure disclosure-has-popup">
    //   <summary class="mobile-facets__open-wrapper focus-offset">
    //     <span class="mobile-facets__open">
    //       ${iconFilterContent}
    //       <span class="mobile-facets__open-label button-label large-up-hide">
    //         ${label}
    //       </span>
    //     </span>
    //   </summary>
    // </div>
    const label = `${this.settings.filterAndSort} ${count ? `(${count})` : ''}`;
    const iconFilter = this.querySelector('algolia-icon-filter');
    const iconFilterContent = iconFilter ? iconFilter.render() : '';

    const div = document.createElement('div');
    div.classList.add('mobile-facets__disclosure', 'disclosure-has-popup');

    const summary = document.createElement('summary');
    summary.classList.add('mobile-facets__open-wrapper', 'focus-offset');
 
    const span = document.createElement('span');
    span.classList.add('mobile-facets__open');

    const spanLabel = document.createElement('span');
    spanLabel.classList.add('mobile-facets__open-label', 'button-label', 'large-up-hide');
    spanLabel.textContent = label;

    span.appendChild(iconFilterContent);
    span.appendChild(spanLabel);

    summary.appendChild(span);

    div.appendChild(summary);

    return div;
  }

  /**
   * Toggles the visibility of the facets container.
   * @returns {void}
   */
  toggleRefinements() {
    const facets = document.querySelector('.ais-facets');
    if (!facets) return;

    facets.classList.toggle('ais-facets__shown');
  }
}

customElements.define("algolia-show-current-refinements", AlgoliaShowCurrentRefinements);